// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Unlock = function Unlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.875 5a3.124 3.124 0 0 1 6.098-.96.94.94 0 0 0 1.18.605.94.94 0 0 0 .605-1.18A5 5 0 0 0 5 5v2.5H3.75a2.5 2.5 0 0 0-2.5 2.5v7.5c0 1.379 1.121 2.5 2.5 2.5h12.5c1.379 0 2.5-1.121 2.5-2.5V10c0-1.379-1.121-2.5-2.5-2.5H6.875zm-3.75 5c0-.344.281-.625.625-.625h12.5c.344 0 .625.281.625.625v7.5a.627.627 0 0 1-.625.625H3.75a.627.627 0 0 1-.625-.625z"
  }));
};
